/**
 * Velora for Android glue. Both components render nothing and do nothing in
 * a browser or the desktop app.
 *
 * - `AndroidSessionSync` (inside the session provider, so on the sign-in
 *   page too): tells the app when someone is fully signed in or signed out,
 *   which drives the app lock and whether a push may show, and registers the
 *   phone for pushes after a full sign-in.
 * - `AndroidNavigation` (in the shell): a deep link or a notification tap
 *   moves this page in-app instead of reloading it.
 */
import { useRouter } from '@tanstack/react-router';
import { useEffect } from 'react';
import { isAndroidApp, onAndroidMessage, tellAndroidSession } from './bridge.js';
import { registerAndroidPush } from './push.js';

export interface AndroidSessionSyncProps {
  /** The session state kind ('active', 'signed_out', 'locked', ...). */
  kind: string;
  userId: string | null;
}

export function AndroidSessionSync({ kind, userId }: AndroidSessionSyncProps) {
  useEffect(() => {
    if (!isAndroidApp()) return;
    if (kind === 'active' && userId) {
      tellAndroidSession(true);
      void registerAndroidPush(userId);
    } else if (kind === 'signed_out') {
      tellAndroidSession(false);
    }
  }, [kind, userId]);
  return null;
}

export function AndroidNavigation() {
  const router = useRouter();
  useEffect(
    () =>
      onAndroidMessage((m) => {
        if (m.type === 'navigate') router.history.push(m.path);
      }),
    [router],
  );
  return null;
}
